module.exports = __webpack_public_path__ + "static/media/pan-diario-80g-b.8c6a6eb7.webp";